import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_LOGIN_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { UpdateLoginDateData, UpdateLoginDateResult } from '../types/updateLoginDate.types';

export const updateLoginDate = (builder: BuilderType) =>
  builder.mutation<UpdateLoginDateData, void>({
    query: () => ({
      data: { RequirePhoto: true },
      method: 'POST',
      url: UPDATE_LOGIN_URL,
    }),
    transformResponse: (response: GenericApiResponse<UpdateLoginDateResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result.Data;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
